import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Link from '@cotyorg/ccx-atoms/Link';
import Icon from '@cotyorg/ccx-atoms/Icon';
import R from 'ramda';
import classNames from 'classnames';
import Heading from '@cotyorg/ccx-atoms/Heading';

export const generateSocialHeadingClassNames = ({ socialAlignment }) => classNames(
  'flex-container',
  'social-heading',
  `align-${socialAlignment}`,
);

export const generateSocialListClassNames = ({ socialAlignment }) => classNames(
  'flex-container',
  'social-list',
  `align-${socialAlignment}`,
);

const Social = ({
  heading,
  links,
  iconSize = 'small',
  socialIconSrc,
  socialAlignment = 'center',
  linkTarget,
  rel,
  socialIconWidth = 20,
  socialIconHeight,
}) => (
  <Fragment>
    {heading && (
      <Heading level={3} extraClass={generateSocialHeadingClassNames({ socialAlignment })}>{heading}</Heading>
    )}
    {Array.isArray(links) && (
      <ul className={generateSocialListClassNames({ socialAlignment })}>
        {links.map(({ name, filename, url }) => (
          <li
            data-test="social-list-item"
            className="social-list__item"
            key={filename}
          >
            <Link
              link={url}
              extraClass="icon-link"
              target={linkTarget}
              rel={rel}
              title={name}
            >
              <Icon
                loading="lazy"
                extraClass="social-list__icon"
                iconSrc={`${R.prop(filename)(socialIconSrc)}`}
                size={iconSize}
                width={socialIconWidth}
                height={socialIconHeight}
                alt={name}
              />
            </Link>
          </li>
        ))}
      </ul>
    )}
  </Fragment>
);

Social.propTypes = {
  heading: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  })),
  iconSize: PropTypes.oneOf(['small', 'medium', 'large']),
  socialAlignment: PropTypes.oneOf(['left', 'right', 'center']),
  socialIconSrc: PropTypes.objectOf(PropTypes.string),
  linkTarget: PropTypes.string,
  rel: PropTypes.string,
  socialIconWidth: PropTypes.number,
  socialIconHeight: PropTypes.number,
};

export default Social;
